import "./app.postcss";
import App from "./App.svelte";


window.dd = console.log;

const app = new App({
  target: document.getElementById("app"),
});

export default app;
